import { cloneObject } from "../scripts/cloneObject";

/**
 * Заменяет всех детей элемента их клонами
 * @param {Object} el - Элемент, чьих детей нужно заменить клонами
 */
export function replaceChildrenWithClones(el) {
    const originalChildren = [...el.children]; // Создаем копию массива детей
    originalChildren.forEach((child) => {
        const clonedChild = cloneObject(child); // Клонируем ребенка
        el.children.push(clonedChild); // Добавляем клонированного ребенка
    });
    // Удаляем оригинальных детей
    originalChildren.forEach((child) => {
        const index = el.children.indexOf(child);
        if (index !== -1) {
            el.children.splice(index, 1);
        }
    });
}
